import { render, staticRenderFns } from "./ReferContent.vue?vue&type=template&id=7195e102&scoped=true"
import script from "./ReferContent.vue?vue&type=script&lang=js"
export * from "./ReferContent.vue?vue&type=script&lang=js"
import style0 from "./ReferContent.vue?vue&type=style&index=0&id=7195e102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195e102",
  null
  
)

export default component.exports